
import { IData, ShippingState } from "../types";

export const defaultFormData: IData = {
  _id: "",
  createdAt: "",
  updatedAt: "",
  stateId: [],
  priceItems: [],
  priceItemsForm: {
    min: 0,
    max: 0,
    price: 0
  },
  states: []
};

export const initialState: ShippingState = {
  formData: {
    ...defaultFormData,
  },
  list: [],
  stateList: [],
  allList: [],
  loading: false,
  buttonLoading: false,
  toggleLoading: false,
  search: "",
  pageNo: 1,
  pageSize: 30,
  totalRow: 0,
  orderBy: "",
  orderDir: "",
  itemsLoading: false,
};
